/**
 * A version 4 uuid. `crypto.randomUUID()` exists only in secure contexts, so plain http on a LAN
 * address falls back to building one from `getRandomValues`. Never `generateUuid.js`, whose ids are
 * three Math.random() strings with dots in them.
 */
export default function uuid(cryptoSource = globalThis.crypto) {
	if(cryptoSource && typeof cryptoSource.randomUUID === 'function') {
		return cryptoSource.randomUUID();
	}
	const bytes = new Uint8Array(16);
	if(cryptoSource && typeof cryptoSource.getRandomValues === 'function') {
		cryptoSource.getRandomValues(bytes);
	} else {
		for(let i = 0; i < bytes.length; i++) {
			bytes[i] = Math.floor(Math.random() * 256);
		}
	}
	bytes[6] = (bytes[6] & 0x0f) | 0x40;
	bytes[8] = (bytes[8] & 0x3f) | 0x80;
	const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
	return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
